import React, {Component} from 'react';
import {Modal} from 'semantic-ui-react';

class DeleteModal extends Component {
  render() {
    const {deleteFunction, trigger} = this.props;
    return (
      <Modal
        centered
        size='mini'
        trigger={<span>{trigger}</span>}
        header='¿Está seguro que desea eliminar el item seleccionado?'
        actions={[
          {'key': 'cancel', 'content': 'Cancelar'},
          {
            'key': 'done',
            'content': 'Confirmar',
            'positive': true,
            'onClick': deleteFunction,
            'primary': true,
          },
        ]}
      />
    );
  }
}

export default DeleteModal;
